import React, { useEffect, useState } from "react";
import generatePDF from "../services/AwardsReportGenerator";
import axios from "axios";
import TicketsComponent from "./TicketsComponent";

const Tickets = () => {
  
  const [tickets, setTickets] = useState([]);
  

  useEffect(() => {
    const getAllTickets = async () => {
      try {
        const response = await axios.get("http://89.46.196.228:3000/api/dogs");
        setTickets(response.data);
      } catch (err) {
        console.log("error");
      }
    };
    getAllTickets();
  }, []);

const reportTickets = tickets.filter(ticket => ticket.ime === 'Lili');
  
  return (
    <div>
      <div className="container mb-4 mt-4 p-3">
        <div className="row">
          {false ? (
            <> </>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => generatePDF(reportTickets)}
            >
              Generate monthly report
            </button>
          )}
        </div>
      </div>
      <TicketsComponent tickets={tickets} />
    </div>
  );
};

export default Tickets;